
/* eslint-disable */
import { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getEnumAll } from "components/axios/commonAxios";
import { getEquipmentCategoriesByQuery } from "components/axios/equipmentCategoryAxios";
import { getUsersByQuery } from "components/axios/userAxios";
import { EnumApiContext } from "contexts/EnumApiContext";

function EnumValuesStorage({ children }) {
  const queryClient = useQueryClient();
  const { loginId } = useSelector(state => state.user);

  const [role, setRole] = useState('NONE');

  const { data: enumValues = {} } = useQuery(['enumValues'], getEnumAll, 
    // {staleTime: 1000 * 60 * 5, cacheTime: 1000 * 60 * 10}
  );

  const { data: equipmentCategoryLevel1s = [] } = useQuery(
    ['equipmentCategoryLevel1s'],
    () => getEquipmentCategoriesByQuery({ depth: 1, size: 100, sort: "name,asc" })
      .then(data => data?._embedded?.equipmentCategories || []),
      { enabled: role !== 'NONE' && loginId !== 'NONE' }
    // { staleTime: 1000 * 60 * 5, cacheTime: 1000 * 60 * 10 }
  );

  useEffect(() => {
    async function fetchUserRole() {
      const data = await queryClient.fetchQuery(
        ['userByLoginId', loginId],
        () => getUsersByQuery({ loginId }).then(data => data?._embedded?.users?.[0]?.role || 'NONE')
      );
      setRole(data);
    }

    if (loginId && loginId !== 'NONE') fetchUserRole();
  }, [loginId, queryClient]);

  const getEnumValueByEnumName = (enumName) => enumValues?.[enumName] || null;

  const getEnumValueByEnumNameAndCode = (enumName, code) => {
    return getEnumValueByEnumName(enumName)?.filter(data => data.code === code) || null;
  };

  return (
    <EnumApiContext.Provider value={{ enumValues, getEnumValueByEnumName, getEnumValueByEnumNameAndCode, equipmentCategoryLevel1s, role }}>
      {children}
    </EnumApiContext.Provider>
  );
}

export default EnumValuesStorage;
